import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import { Can, ReactTable } from "components";

import type { Brand } from "models";

type BrandGroupBrandsTableProps = {
  brands?: Brand[];
  onEditBrand: (brand: Brand) => void;
  onDeleteBrand: (brandId: number) => void;
};

const columnHelper = createColumnHelper<Brand>();

export const BrandGroupBrandsTable = ({ brands = [], onEditBrand, onDeleteBrand }: BrandGroupBrandsTableProps) => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      columnHelper.accessor(row => row, {
        id: "name",
        size: 228,
        header: () => <span className="no-wrap-text"> {t("v8_brand", "Brand")} </span>,
        cell: ({ row: { original } }) => (
          <div className="name-container">
            <div className={original.is_active ? "active" : "inactive"} />
            <span className="no-wrap-text">{original.name}</span>
          </div>
        )
      }),
      columnHelper.accessor(row => row, {
        id: "vin_prefix",
        size: 300,
        header: () => <span className="no-wrap-text"> {t("v8_vin_number", "Vin #")} </span>,
        cell: ({ row: { original } }) => <span className="no-wrap-text">{original.vin_prefix}</span>
      }),
      columnHelper.accessor(row => row, {
        id: "button_label",
        size: 300,
        header: () => <span className="no-wrap-text"> {t("v8_button_label", "Button label")} </span>,
        cell: ({ row: { original } }) => <span className="no-wrap-text">{original.button_label}</span>
      }),

      columnHelper.accessor(row => row, {
        id: "actions",
        header: "",
        size: 60,
        cell: ({ row: { original: brand } }) => {
          return (
            <div className="actions-container">
              <Can I="update" the="brands">
                <div className="action-edit-button-container" onClick={() => onEditBrand(brand)}>
                  <Icon className="icon pen to square edit-icon action-button-icon-center" color="#32bf53" />
                </div>
              </Can>
              <Can I="delete" the="brands">
                <div className="action-button-container" onClick={() => onDeleteBrand(brand.id)}>
                  <Icon className="trash action-button-icon-center" color="red" />
                </div>
              </Can>
            </div>
          );
        }
      })
    ],
    [t, onEditBrand, onDeleteBrand]
  );

  return <ReactTable columns={columns} data={brands} />;
};
